import React, { useState, useEffect } from 'react'
import { useLocation, useNavigate } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlus, faPenToSquare, faXmark, faCheck } from '@fortawesome/free-solid-svg-icons';
import Pagination from '../../components/layout/Pagination'
import { toast } from 'react-toastify';

function Popups() {
    const API_URL = process.env.REACT_APP_API_URL;
    const token = localStorage.getItem('authToken');
    const [popups, setPopups] = useState([])
    const [loading, setLoading] = useState(false);
    const [totalPages, setTotalPages] = useState(0);
    const [totalItems, setTotalItems] = useState(0);
    const [currentPage, setCurrentPage] = useState(1);
    const [sortBy, setSortBy] = useState('');
    const [pageSize, setPageSize] = useState(10);
    const [selectedPopup, setSelectedPopup] = useState([])
    const [modalOpen, setModalOpen] = useState(false);
    const [errors, setErrors] = useState({});
    const [errorMessage, setErrorMesage] = useState('')

    const location = useLocation()
    const navigate = useNavigate();

    useEffect(() => {
        fetchPopups(sortBy, pageSize, currentPage)
    }, [location.search])

    const openAddModal = () => {
        setSelectedPopup({
            title: '',
            message: '',
            isActive: false,
            startDate: new Date(),
            endDate: new Date(),
            isTimeout: false,
            timeoutSeconds: 0
        });
        setModalOpen(true);
    };

    const fetchPopups = async (sortBy, pageSize, currentPage) => {
        try {
            setLoading(true)
            const response = await fetch(`${API_URL}/popup/getPopups?sortBy=${sortBy}&pageNumber=${currentPage}&pageSize=${pageSize}`, {
                method: 'GET',
                headers: {
                    "Authorization": `Bearer ${token}`,
                    'Content-Type': 'application/json',  // Specify the content type
                }
            })

            if (response.status === 401) {
                navigate('/');
            }

            const result = await response.json()
            if (result?.data?.popups) {
                const newQueryParams = new URLSearchParams(location.search);
                setPopups(result.data.popups);
                setTotalPages(result.data.totalPages);
                setTotalItems(result.data.totalItems);
                setLoading(false)

                if (result.data.totalPages) {
                    newQueryParams.set("totalPages", result.data.totalPages);
                }
                //navigate({ search: newQueryParams.toString() });
            } else {
                setPopups([])
                setLoading(false)
            }
        }
        catch (error) {
        }
    }

    const handlePageSizeChange = (e) => {
        const newQueryParams = new URLSearchParams(location.search);
        newQueryParams.set('currentPage', '1');
        const { name, value } = e.target;

        if (value) {
            newQueryParams.set(name, value);
        } else {
            newQueryParams.delete(name); // Избриши ако нема вредност
        }
        setPageSize(e.target.value);

        navigate({ search: newQueryParams.toString() });
    };

    const handleSortByChange = (e) => {
        const newQueryParams = new URLSearchParams(location.search);
        const { name, value } = e.target;

        if (value) {
            newQueryParams.set(name, value);
        } else {
            newQueryParams.delete(name); // Избриши ако нема вредност
        }
        setSortBy(e.target.value);

        navigate({ search: newQueryParams.toString() });
    };

    const handlePageChange = (page) => {
        const newQueryParams = new URLSearchParams(location.search);

        if (page) {
            newQueryParams.set('currentPage', page);
        } else {
            newQueryParams.delete('currentPage');
        }
        navigate({ search: newQueryParams.toString() });

        setCurrentPage(page)
    };

    const convertDateTime = (created) => {
        if (created != null) {
            const dateObject = new Date(created);
            const options = { day: '2-digit', month: '2-digit', year: 'numeric' };
            const datePart = dateObject.toLocaleDateString('en-GB', options);
            const timePart = dateObject.toLocaleTimeString();
            return `${datePart} ${timePart}`;
        }
    }

    const handlePopup = () => {
        if (selectedPopup.id) {
            handlePopupEdit()
        } else {
            handlePopupAdd()
        }
    };

    const validateInputs = () => {
        const newErrors = {};

        if (!selectedPopup.title) newErrors.title = "Насловот е задолжителен!";
        if (selectedPopup.message === "" || selectedPopup.message === null || selectedPopup.message === undefined)
            newErrors.message = "Пораката е задолжителна!";
        if (selectedPopup.startDate === "" || selectedPopup.startDate === null || selectedPopup.startDate === undefined)
            newErrors.ammount = "Датумот за почеток е задолжителен!";
        if (selectedPopup.endDate === "" || selectedPopup.endDate === null || selectedPopup.endDate === undefined)
            newErrors.ammount = "Датумот за крај е задолжителен!";


        return Object.keys(newErrors).length > 0 ? newErrors : null;  // Врати го новиот објект со грешки ако има или null ако нема грешки
    };


    const handlePopupEdit = async () => {
        setLoading(true)
        const validationErrors = validateInputs();

        if (validationErrors) {
            setErrors(validationErrors);
            setLoading(false)
            return;
        }

        const response = await fetch(`${API_URL}/popup/${selectedPopup.id}`, {
            method: 'PUT',
            headers: {
                "Authorization": `Bearer ${token}`,
                'Content-Type': 'application/json',  // Specify the content type
            },
            body: JSON.stringify(selectedPopup),
        })

        const result = await response.json()

        if (result.statusCode === 204) {
            setPopups(popups.map(popup =>
                popup.id === selectedPopup.id ? selectedPopup : popup
            ));
            closeEditModal();
            setLoading(false)
            toast.success(`${selectedPopup.title} е успешно ажуриран!`);
        } else {
            setErrors({});
            setErrorMesage("Попапот не е успешно променет!");
            setLoading(false)
        }
    };

    const handlePopupAdd = async () => {
        setLoading(true)
        const validationErrors = validateInputs();

        if (validationErrors) {
            setErrors(validationErrors);
            setLoading(false)
            return;
        }

        const response = await fetch(`${API_URL}/popup/addPopup`, {
            method: 'POST',
            headers: {
                "Authorization": `Bearer ${token}`,
                'Content-Type': 'application/json',  // Specify the content type
            },
            body: JSON.stringify(selectedPopup),
        })

        const result = await response.json()

        if (result.statusCode === 201) {
            setPopups([...popups, result.data]);
            closeEditModal();
            setLoading(false)
            toast.success(`${selectedPopup.title} е успешно додаден!`);
        } else {
            setErrors({});
            setErrorMesage("Попапот не е успешно додаден!");
            setLoading(false)
        }
    };

    const closeEditModal = () => {
        setModalOpen(false);
        setSelectedPopup(null);
        setErrors({});
        setErrorMesage("")
    };

    const openEditModal = (popup) => {
        setSelectedPopup(popup);
        setModalOpen(true);
    };

    const handleQuantityChange = (e) => {
        const updatedPopup = {
            ...selectedPopup,
            isActive: parseInt(e.target.value) > 0 ? selectedPopup.isActive : false,
            quantity: parseInt(e.target.value)
        };
        setSelectedPopup(updatedPopup);
    };




    return (
        <div className="p-6">
            <div className='flex flex-col'>
                <div className='ml-auto'>
                    <label htmlFor='pageSize'>Прикажи:</label>
                    <select
                        className="mb-4"
                        name='pageSize'
                        id='pageSize'
                        value={pageSize}
                        onChange={handlePageSizeChange}
                    >
                        <option value="10">10</option>
                        <option value="20">20</option>
                        <option value="30">30</option>
                        <option value="50">50</option>
                    </select>
                </div>
                <div className='ml-auto'>
                    <select
                        className="mb-4"
                        name='sortBy'
                        value={sortBy}
                        onChange={handleSortByChange}
                    >
                        <option value="">Стандардно подредување</option>
                        <option value="created_desc">Најновите први</option>
                        <option value="created_asc">Најстарите први</option>
                    </select>
                </div>
                <div className="flex justify-between">
                    <div className="ml-auto">
                        <button className='btn btn-primary btn-sm' onClick={openAddModal}>
                            <FontAwesomeIcon icon={faPlus} />
                            Додади Попуп
                        </button>
                    </div>
                </div>
            </div>
            <div className="overflow-x-auto">
                <table className="table table-zebra table-sm min-w-[600px] max-w-[96%] text-[13px]">
                    <thead>
                        <tr className='text-[13px]'>
                            <th className='w-[30px]'>Id</th>
                            <th className='p-[5px]'>Наслов</th>
                            <th className='p-[5px]'>Порака</th>
                            <th className='p-[5px]'>Активен</th>
                            <th className='p-[5px]'>Почеток</th>
                            <th className='p-[5px]'>Крај</th>
                            <th className='p-[5px]'>Timeout</th>
                            <th className='p-[5px]'>IsTimeout</th>
                        </tr>
                    </thead>
                    <tbody>
                        {popups.map(popup => (
                            <tr key={popup.id}>
                                <td>{popup.id}</td>
                                <td className='font-semibold text-base'>{popup.title}</td>
                                <td className='font-semibold text-base'>{popup.message}</td>
                                <td>{popup.isActive ? <FontAwesomeIcon className='text-green-500 text-xl transform scale-110' icon={faCheck} />
                                    : <FontAwesomeIcon className='text-red-500 text-xl transform scale-110' icon={faXmark} />}</td>
                                <td>{convertDateTime(popup.startDate)}</td>
                                <td>{convertDateTime(popup.endDate)} </td>
                                <td>{popup.isTimeout ? <FontAwesomeIcon className='text-green-500 text-xl transform scale-110' icon={faCheck} />
                                    : <FontAwesomeIcon className='text-red-500 text-xl transform scale-110' icon={faXmark} />}</td>
                                <td className='font-semibold text-base'>{popup.timeoutSeconds}</td>
                                <td>
                                    <div className="tooltip" data-tip="Измени го купонот">
                                        <button
                                            className="btn btn-sm btn-primary ml-2"
                                            onClick={() => openEditModal(popup)}
                                        >
                                            <FontAwesomeIcon icon={faPenToSquare} />
                                        </button>
                                    </div>
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
                {popups.length > 0 && (
                    <>
                        <div className='text-center'>Тековна страна: {currentPage}</div>
                        <div className='text-center'>Вкупно производи: {totalItems}</div>
                        <Pagination
                            totalPages={totalPages}
                            currentPage={currentPage}
                            onPageChange={handlePageChange}
                        /></>
                )}
            </div>
            {modalOpen && selectedPopup && (
                <div className="modal modal-open">
                    <div className="modal-box max-w-[500px]">
                        <div className="flex items-center justify-center p-4 flex-wrap">
                            <div className="mx-auto w-full bg-white mb-auto">
                                <div>
                                    <h1 className='text-4xl font-bold mb-8 mt-8 text-center'>{selectedPopup.id ? 'Промени податоци за купон' : 'Додај нов купон'}</h1>
                                </div>
                                {selectedPopup.id && (<p className='text-base'>Id - {selectedPopup.id}</p>)}
                                <div className="-mx-3 flex flex-wrap">
                                    <div className="w-full px-3 sm:w-1/2">
                                        <div className="form-control">
                                            <label className="cursor-pointer label justify-start">
                                                <span className="label-text">Статус:</span>
                                                <input type="checkbox" className="checkbox checkbox-success ml-4" name="isActive" id="isActive" value={selectedPopup.isActive} checked={selectedPopup.isActive}
                                                    onChange={(e) => setSelectedPopup({ ...selectedPopup, isActive: e.target.checked })} />
                                            </label>
                                        </div>
                                    </div>
                                    <div className="w-full px-3 ">
                                        <div className="mb-2">
                                            <label htmlFor="title" className="mb-3 block text-base font-medium text-[#07074D]">
                                                Наслов<span className='text-red-500 tooltip' data-tip="Насловот е задолжителен">*</span>
                                            </label>
                                            <input type="text" name="title" id="title" value={selectedPopup.title}
                                                required
                                                onChange={(e) => setSelectedPopup({ ...selectedPopup, title: e.target.value })}
                                                className="w-full rounded-md border border-[#e0e0e0] bg-white py-2 px-3 text-base font-medium text-[#6B7280] outline-none focus:border-[#6A64F1] focus:shadow-md" />
                                            {errors.title && (
                                                <p className="text-red-500 text-sm mt-2">{errors.title}</p>
                                            )}
                                        </div>
                                    </div>
                                    <div className="w-full px-3 ">
                                        <div className="mb-2">
                                            <label htmlFor="message" className="mb-3 block text-base font-medium text-[#07074D]">
                                                Порака<span className='text-red-500 tooltip' data-tip="Пораката е задолжителна">*</span>
                                            </label>
                                            <textarea name="message" id="message" value={selectedPopup.message}
                                                required
                                                onChange={(e) => setSelectedPopup({ ...selectedPopup, message: e.target.value })}
                                                className="w-full rounded-md border border-[#e0e0e0] bg-white py-2 px-3 text-base font-medium text-[#6B7280] outline-none focus:border-[#6A64F1] focus:shadow-md" />
                                            {errors.message && (
                                                <p className="text-red-500 text-sm mt-2">{errors.message}</p>
                                            )}
                                        </div>
                                    </div>
                                    <div className="flex flex-wrap -mx-3">
                                        <div className="w-full px-3 sm:w-1/2">
                                            <div className="form-control mt-8">
                                                <label className="cursor-pointer label justify-start">
                                                    <span className="label-text">IsTimeout:</span>
                                                    <input type="checkbox" className="checkbox checkbox-success ml-4" name="isTimeout" id="isTimeout" value={selectedPopup.isTimeout} checked={selectedPopup.isTimeout}
                                                        onChange={(e) => setSelectedPopup({ ...selectedPopup, isTimeout: e.target.checked })} />
                                                </label>
                                            </div>
                                        </div>
                                        <div className="w-full px-3 sm:w-1/2">
                                            <div className="mb-2">
                                                <label htmlFor="timeoutSeconds" className="mb-3 block text-base font-medium text-[#07074D]">
                                                    Timeout секунди
                                                </label>
                                                <input
                                                    type="number"
                                                    name="timeoutSeconds"
                                                    id="timeoutSeconds"
                                                    value={selectedPopup.timeoutSeconds}
                                                    required
                                                    onChange={(e) => setSelectedPopup({ ...selectedPopup, timeoutSeconds: e.target.value })}
                                                    className="w-full rounded-md border border-[#e0e0e0] bg-white py-2 px-3 text-base font-medium text-[#6B7280] outline-none focus:border-[#6A64F1] focus:shadow-md"
                                                />
                                            </div>
                                        </div>
                                        <div className="w-full px-3 sm:w-1/2">
                                            <div className="mb-2">
                                                <label htmlFor="startDate" className="mb-3 block text-base font-medium text-[#07074D]">
                                                    Почеток<span className='text-red-500 tooltip' data-tip="Почетокот е задолжителен">*</span>
                                                </label>
                                                <input
                                                    type="datetime-local"
                                                    name="startDate"
                                                    id="startDate"
                                                    value={selectedPopup.startDate ? new Date(selectedPopup.startDate).toISOString().slice(0, 16) : ""}
                                                    required
                                                    onChange={(e) => setSelectedPopup({ ...selectedPopup, startDate: e.target.value })}
                                                    className="w-full rounded-md border border-[#e0e0e0] bg-white py-2 px-3 text-base font-medium text-[#6B7280] outline-none focus:border-[#6A64F1] focus:shadow-md"
                                                />
                                                {errors.startDate && (
                                                    <p className="text-red-500 text-sm mt-2">{errors.startDate}</p>
                                                )}
                                            </div>
                                        </div>
                                        <div className="w-full px-3 sm:w-1/2">
                                            <div className="mb-2">
                                                <label htmlFor="endDate" className="mb-3 block text-base font-medium text-[#07074D]">
                                                    Крај<span className='text-red-500 tooltip' data-tip="Крајот е задолжителен">*</span>
                                                </label>
                                                <input
                                                    type="datetime-local"
                                                    name="endDate"
                                                    id="endDate"
                                                    value={selectedPopup.endDate ? new Date(selectedPopup.endDate).toISOString().slice(0, 16) : ""}
                                                    required
                                                    onChange={(e) => setSelectedPopup({ ...selectedPopup, endDate: e.target.value })}
                                                    className="w-full rounded-md border border-[#e0e0e0] bg-white py-2 px-3 text-base font-medium text-[#6B7280] outline-none focus:border-[#6A64F1] focus:shadow-md"
                                                />
                                                {errors.endDate && (
                                                    <p className="text-red-500 text-sm mt-2">{errors.endDate}</p>
                                                )}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="modal-action">
                                {loading && (<span className="loading loading-spinner loading-xs"></span>)}
                                <button className="btn btn-success" onClick={handlePopup} disabled={loading}>Зачувај</button>
                                <button className="btn btn-warning" onClick={closeEditModal} disabled={loading}>Откажи</button>
                            </div>
                            {errorMessage && (<p className='text-red-600 text-right mt-4'>{errorMessage}</p>)}
                        </div>
                    </div>
                </div>
            )}
        </div>
    )
}

export default Popups